import Vue from 'vue'
import _ from 'lodash'
import $ from 'jQuery'

export default {

  // fn: return all item.val values from a form object
  getVals (form) {
    // init response
    let response = {}

    // loop form object
    _.forEach(form, function (item, key) {
      // if item is structured how we expect
      if (key && _.isObject(item)) {
        // add it's value to the response
        response[key] = item.val
      }
    })

    // return response
    return response
  },

  // fn: returns true if a form has no invalid states
  hasNoInvalid (form) {
    // init flag
    let noInvalid = true

    // loop form object
    _.forEach(form, function (item) {
      // if item in form has an invalid state
      if (_.isObject(item) && item.state === 'invalid') {
        // tip flag
        noInvalid = false
        return false
      }
    })

    return noInvalid
  },

  // fn: set a form elements state / feedback
  clearFeedback (form) {
    // loop form object
    _.forEach(form, function (item) {
      // if item is structured how we expect
      if (_.isObject(item)) {
        // reset state & clear feedback
        item.state = null
        item.invalidFeedback = ''
      }
    })
  },

  // fn: find the first error in a form and focus it
  focusFirstError (options) {
    Vue.nextTick(() => {
      // init jQuery element
      // if location is modal set css to modal wrapper else use options.el
      let $el = (options && options.location && options.location === 'modal') ? $('.modal.show') : $(options.el)

      // if jQuery element is defined
      if (_.isObject($el) && _.isFunction($el.find)) {
        // focus the first invalid input
        $el.find('input.is-invalid, select.is-invalid, textarea.is-invalid').first().focus()
      }
    })
  },

  // fn: find/return server errors or defaults
  parseError (response) {
    // if response object -> props error/message or default
    if (_.isObject(response)) return response.error || response.message || 'An error has occurred'

    // if response string -> response or default
    else if (_.isString(response)) return response || 'An error has occurred'

    // else default
    else return 'An error has occurred'
  },

  // fn: reset val's in a form object
  reset (form) {
    // loop form object
    _.forEach(form, function (item) {
      // if item is structured how we expect
      if (_.isObject(item)) {
        if (_.isArray(item.val)) {
          item.val = []
        } else {
          item.val = ''
        }
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/$glForm.js